/**
 * Actors - Single (detail view) - Manage medias (photos, videos, audio files)
 */

'use strict';

var ui = require('../misc/layout');

// Constructor
var FrontActorsSingleManageMedias = function () {

    if (!$('body').hasClass('single-cm-actors')) {
        return;
    }

    $(document).ready((function () {
        this.initMaterializeComponents();
        this.initSortable();
        this.openSideNav();
        this.handleMediaDelete();
        this.submitPhotosForm();
        this.submitVideosForm();
        this.submitAudiosForm();
        this.modalExitWithoutSavingMedia();
    }).bind(this));
};

FrontActorsSingleManageMedias.prototype = {
    lockAjaxForm: false,

    /**
     * Initialize MaterializeCSS components.
     */
    initMaterializeComponents: function() {
        $('.tooltipped-video').tooltip({delay: 50});
    },

    /**
     * Let the actor sort its pictures and videos (with a simple drag'n'drop).
     */
    initSortable: function() {
        $('#form-manage-photos .content-pictures').sortable();
        $('#form-manage-videos .content-videos').sortable();
    },

    /**
     * Open the side nav panels to allow the actor to manage its medias (photos, videos, audio files).
     */
    openSideNav: function() {
        // Open side nav to manage photos
        $('#btn-manage-photos').on('click', function(e) {
            e.preventDefault();

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            $('#form-manage-photos .content-pictures .chip').remove();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_media_photos',
                    security: comedien.security
                }
            }).done(function (response) {
                if (response.success) {
                    var pictures = response.data.pictures;

                    for (var key in pictures) {
                        if (pictures[key]['html'].length > 0) {
                            $('#form-manage-photos .content-pictures').append('<div class="chip" data-type="pictures" data-id="' + pictures[key]['id'] + '">' + pictures[key]['html'] + '' + '<i class="material-icons close">close</i></div>');
                        }
                    }

                    // Open side nav
                    $('.edition-media .button-collapse[data-target="sidebar-manage-photos"]').trigger('click');

                    $('.toastLoading').fadeOut(500, function() {
                        $('.toastLoading').remove();
                    });
                } else {
                    $('.toastLoading').remove();
                    M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }
            }).fail(function (jqXHR, textStatus) {
                console.log("Request failed: " + textStatus);
                $('.toastLoading').remove();
                M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            });
        });

        // Open side nav to manage videos
        $('#btn-manage-videos').on('click', function(e) {
            e.preventDefault();

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            $('#form-manage-videos .content-videos .chip').remove();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_media_videos',
                    security: comedien.security
                }
            }).done(function (response) {
                if (response.success) {
                    var videos = response.data.videos;

                    for (var key in videos) {
                        if (videos[key]['html'].length > 0) {
                            if (videos[key]['title'].length > 0) {
                                var title = videos[key]['title'];
                            } else {
                                var title = videos[key]['html'];
                            }
                            $('#form-manage-videos .content-videos').append('<div class="chip" data-type="videos" data-id="' + videos[key]['id'] + '" data-password="' + videos[key]['password'] + '">' + title + '<i class="material-icons close">close</i></div>')
                        }
                    }

                    // Open side nav
                    $('.edition-media .button-collapse[data-target="sidebar-manage-videos"]').trigger('click');

                    $('.toastLoading').fadeOut(500, function() {
                        $('.toastLoading').remove();
                    });
                } else {
                    $('.toastLoading').remove();
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }
            }).fail(function (jqXHR, textStatus) {
                console.log("Request failed: " + textStatus);
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            });
        });

        // Open side nav to manage audios
        $('#btn-manage-audios').on('click', function(e) {
            e.preventDefault();

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            $('#form-manage-audios .content-audios .chip').remove();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_media_audios',
                    security: comedien.security
                }
            }).done(function (response) {
                if (response.success) {
                    var audios = response.data.audios;

                    for (var key in audios) {
                        if (audios[key]['html'].length > 0) {
                            $('#form-manage-audios .content-audios').append('<div class="chip" data-type="audios" data-id="' + audios[key]['id'] + '">' + audios[key]['html'] + '<i class="material-icons close">close</i></div>')
                        }
                    }

                    // Open side nav
                    $('.edition-media .button-collapse[data-target="sidebar-manage-audios"]').trigger('click');

                    $('.toastLoading').fadeOut(500, function() {
                        $('.toastLoading').remove();
                    });
                } else {
                    $('.toastLoading').remove();
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }
            }).fail(function (jqXHR, textStatus) {
                console.log("Request failed: " + textStatus);
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            });
        });
    },

    handleMediaDelete: function() {
        // Delete a photo
        $('.single-cm-actors').on('click', '#form-manage-photos .chip .close', function (e) {
            e.preventDefault();

            console.log('delete photo !!');

            var value = $(this).parent().data('id');
            if ($('[name=deletePictures]').val().length < 1) {
                var newValue = value;
            } else {
                var newValue = $('[name=deletePictures]').val() + ',' + value;
            }
            $('[name=deletePictures]').val(newValue);

            $('#sidebar-manage-photos input[name="mediaChanged"]').val(1);
        });

        // Delete a video
        $('.single-cm-actors').on('click', '#form-manage-videos .chip .close', function (e) {
            e.preventDefault();

            var value = $(this).parent().data('id');
            if ($('[name=deleteVideos]').val().length < 1) {
                var newValue = value;
            } else {
                var newValue = $('[name=deleteVideos]').val() + ',' + value;
            }
            $('[name=deleteVideos]').val(newValue);

            $('#sidebar-manage-videos input[name="mediaChanged"]').val(1);
        });

        // Delete a audio file
        $('.single-cm-actors').on('click', '#form-manage-audios .chip .close', function (e) {
            e.preventDefault();

            console.log('delete audio !!');

            var value = $(this).parent().data('id');
            if ($('[name=deleteAudios]').val().length < 1) {
                var newValue = value;
            } else {
                var newValue = $('[name=deleteAudios]').val() + ',' + value;
            }
            $('[name=deleteAudios]').val(newValue);

            $('#sidebar-manage-audios input[name="mediaChanged"]').val(1);
        });
    },

    submitPhotosForm: function() {
        var self = this;

        var form = $('#form-manage-photos');

        form.submit(function (e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', form).hide();
            $('.row-preloader', form).fadeIn();
            $('.preloader-wrapper', form).fadeIn();

            // Let the user sort its pictures (with a simple drag'n'drop)
            var idImages = '';
            form.find('.content-pictures .chip').each(function(index, element) {
                idImages += $(this).data('id') + ',';
            });
            idImages = idImages.replace(/,\s*$/, "");
            form.find('[name=idPictures]').val(idImages);

            var ajaxAction = 'actors.edit_media';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(form[0]);
                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            // Bug fix Safari 11 / Webkit
            // @link https://stackoverflow.com/questions/49614091/safari-11-1-ajax-xhr-form-submission-fails-when-inputtype-file-is-empty
            // @link https://trac.webkit.org/changeset/230963/webkit
            $("input[type=file]", form).each(function () {
                if ($(this).val() === "") {
                    formdata.delete($(this).attr("name"));
                }
            });

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false
            }).done(function (response) {
                if (response.success) {
                    // Media successfully updated: so do not show the modal window that warn the user
                    // that it will exit without saving the changes...
                    $('#sidebar-manage-photos input[name="mediaChanged"]').val(0);

                    // Replace the content
                    $('#actor .actor-medias-wrapper').html(response.data.html);

                    // Close the side nav
                    $('.sidenav').sidenav('close');

                    // Clean several hidden input
                    form.find('[name=deletePictures]').val('');
                    form.find('[name=idPictures]').val('');

                    // Clean the input file
                    var $el = $('#picture', form);
                    $el.val('');
                    $el.wrap('<form>').closest('form').get(0).reset();
                    $el.unwrap();

                    form.find('[name=picture]').val('');

                    self.cleanForm(form);
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, form).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.row-preloader', form).fadeOut();
                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.row-preloader', form).fadeOut();
                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitVideosForm: function() {
        var self = this;

        var form = $('#form-manage-videos');

        form.submit(function (e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', form).hide();
            $('.row-preloader', form).fadeIn();
            $('.preloader-wrapper', form).fadeIn();

            // Let the user sort its videos (with a simple drag'n'drop)
            var idVideos = '';
            form.find('.content-videos .chip').each(function(index, element) {
                idVideos += $(this).data('id') + ',';
            });
            idVideos = idVideos.replace(/,\s*$/, "");
            form.find('[name=idVideos]').val(idVideos);

            var urlValue = $('#form-manage-videos #video-url').val();

            // If the user forgot to prefix the url with "http://" or "https://", automatically add it
            if (urlValue && !/^(f|ht)tps?:\/\//i.test(urlValue)) {
                urlValue = "https://" + urlValue;
                $('#form-manage-videos #video-url').val(urlValue);
            }

            var ajaxAction = 'actors.edit_media';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(form[0]);
                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            // Bug fix Safari 11 / Webkit
            // @link https://stackoverflow.com/questions/49614091/safari-11-1-ajax-xhr-form-submission-fails-when-inputtype-file-is-empty
            // @link https://trac.webkit.org/changeset/230963/webkit
            $("input[type=file]", form).each(function () {
                if ($(this).val() === "") {
                    formdata.delete($(this).attr("name"));
                }
            });

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false
            }).done(function (response) {
                if (response.success) {
                    // Media successfully updated: so do not show the modal window that warn the user
                    // that it will exit without saving the changes...
                    $('#sidebar-manage-videos input[name="mediaChanged"]').val(0);

                    // Replace the content
                    $('#actor .actor-medias-wrapper').html(response.data.html);

                    // Close the side nav
                    $('.sidenav').sidenav('close');

                    // Clean several hidden input
                    form.find("[name='videos[]']").val('');
                    form.find('[name=deleteVideos]').val('');
                    form.find('[name=idVideos]').val('');

                    $('#video-title', form).val('');
                    $('#video-url', form).val('');
                    $('#video-password', form).val('');

                    self.cleanForm(form);
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, form).addClass('invalid');
                        M.toast({html: '<span>'+item+'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.row-preloader', form).fadeOut();
                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.row-preloader', form).fadeOut();
                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitAudiosForm: function() {
        var self = this;

        var form = $('#form-manage-audios');

        form.submit(function (e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            console.log('submit photos form');

            $('#submit', form).hide();
            $('.row-preloader', form).fadeIn();
            $('.preloader-wrapper', form).fadeIn();

            var ajaxAction = 'actors.edit_media';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(form[0]);
                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            // Bug fix Safari 11 / Webkit
            // @link https://stackoverflow.com/questions/49614091/safari-11-1-ajax-xhr-form-submission-fails-when-inputtype-file-is-empty
            // @link https://trac.webkit.org/changeset/230963/webkit
            $("input[type=file]", form).each(function () {
                if ($(this).val() === "") {
                    formdata.delete($(this).attr("name"));
                }
            });

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false
            }).done(function (response) {
                if (response.success) {
                    // Media successfully updated: so do not show the modal window that warn the user
                    // that it will exit without saving the changes...
                    $('#sidebar-manage-audios input[name="mediaChanged"]').val(0);

                    // Replace the content
                    $('#actor .actor-medias-wrapper').html(response.data.html);

                    // Close the side nav
                    $('.sidenav').sidenav('close');

                    // Clean several hidden input
                    form.find('[name=deleteAudios]').val('');

                    // Clean the input file
                    var $el = $('#audio', form);
                    $el.val('');
                    $el.wrap('<form>').closest('form').get(0).reset();
                    $el.unwrap();

                    form.find('[name=picture]').val('');
                    $('#audio-title', form).val('');

                    self.cleanForm(form);
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, form).addClass('invalid');
                        M.toast({html: '<span>'+item+'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.row-preloader', form).fadeOut();
                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.row-preloader', form).fadeOut();
                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    cleanForm: function (form) {
        // Clean inputs
        form.find('[type=text]:not([type=hidden])').each(function () {
            $(this).val('');
            $(this).removeClass('valid');
        });

        // Clean radio buttons
        form.find('[type=radio]').each(function () {
            $(this).prop('checked', false);
        });

        // Clean textarea
        form.find('textarea').each(function () {
            $(this).val('');
        });

        // Initialize selects
        form.find('select').formSelect();
        form.find('select').find('[value=""]').prop('selected', true);
        form.find('select').formSelect();

        // Clean valid state
        form.find('.file-path').removeClass('valid');
    },

    modalExitWithoutSavingMedia: function() {
        $('#sidebar-manage-photos #picture').on('change', function() {
            $('#sidebar-manage-photos input[name="mediaChanged"]').val(1);
        });

        $('#sidebar-manage-videos #video-url').on('change', function() {
            $('#sidebar-manage-videos input[name="mediaChanged"]').val(1);
        });

        $('#sidebar-manage-audios #audio').on('change', function() {
            $('#sidebar-manage-audios input[name="mediaChanged"]').val(1);
        });

        var $modal = $('#modal-confirm-exit-media-without-saving');

        $('.btn-confirm', $modal).on('click', function() {
            $modal.modal('close');

            if ($modal.hasClass('manage-photos')) {
                $('#sidebar-manage-photos input[name="mediaChanged"]').val(0);
                $('#sidebar-manage-photos .close-side').trigger('click');

                // Clean the input file
                var $el = $('#sidebar-manage-photos #picture');
                $el.val('');
                $el.wrap('<form>').closest('form').get(0).reset();
                $el.unwrap();
            } else if ($modal.hasClass('manage-videos')) {
                $('#sidebar-manage-videos input[name="mediaChanged"]').val(0);
                $('#sidebar-manage-videos .close-side').trigger('click');

                // Clean the input text
                $('#sidebar-manage-videos #video-url').val('');
            } else if ($modal.hasClass('manage-audios')) {
                $('#sidebar-manage-audios input[name="mediaChanged"]').val(0);
                $('#sidebar-manage-audios .close-side').trigger('click');

                // Clean the input file
                var $el = $('#sidebar-manage-audios #audio');
                $el.val('');
                $el.wrap('<form>').closest('form').get(0).reset();
                $el.unwrap();
            }
        });

        $('.btn-cancel', $modal).on('click', function() {
            $modal.modal('close');

            if ($modal.hasClass('manage-photos')) {
                $('#sidebar-manage-photos').animate({
                    scrollTop: $('#sidebar-manage-photos').height()
                }, 500, function() {
                    $('body').css('overflow', 'hidden');
                });
            } else if ($modal.hasClass('manage-videos')) {
                $('#sidebar-manage-videos').animate({
                    scrollTop: $('#sidebar-manage-videos').height()
                }, 500, function() {
                    $('body').css('overflow', 'hidden');
                });
            } else if ($modal.hasClass('manage-audios')) {
                $('#sidebar-manage-audios').animate({
                    scrollTop: $('#sidebar-manage-audios').height()
                }, 500, function() {
                    $('body').css('overflow', 'hidden');
                });
            }
        });
    }
};

module.exports = new FrontActorsSingleManageMedias();